import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { EntityCardBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { PromptLifecycleCard } from '../prompt-lifecycle';

const promptLifecycleCard = EntityCardBlueprint.make({
  name: 'prompt-lifecycle',
  params: {
    filter: 'kind:component',
    loader: async () => <PromptLifecycleCard />,
  },
});

export const catalogPromptLifecycleModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [promptLifecycleCard],
});
